import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const UsageEnvironment = ({ onUsageEnvironmentSelected }) => {
  const [selectedUsageEnvironment, setSelectedUsageEnvironment] =
    useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.usageenvironment) {
        const usageEnvironmentObject = firstResult.usageenvironment;
        if (usageEnvironmentObject.trim() !== "") {
          setVariations(usageEnvironmentObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleUsageEnvironmentClick = (usageenvironment) => {
    setSelectedUsageEnvironment(usageenvironment);
    onUsageEnvironmentSelected(usageenvironment);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Usage Environment:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedUsageEnvironment === variation ? "selected" : ""}`}
            onClick={() => handleUsageEnvironmentClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default UsageEnvironment;
